"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function IdentityUnchecked(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, height: props.size, viewBox: "0 0 16 12.667" },
    _react2["default"].createElement("path", { fill: "#4F74B3", d: "M15.667 12.667H.333A.333.333 0 0 1 0 12.333v-12C0 .149.149 0 .333 0h15.333c.185 0 .334.149.334.333v12a.333.333 0 0 1-.333.334z" }),
    _react2["default"].createElement("circle", { fill: "#FFF", cx: "4.975", cy: "3.468", r: "1.6" }),
    _react2["default"].createElement("path", { fill: "#375EA3", d: "M9.667 2h4.5v.667h-4.5z" }),
    _react2["default"].createElement("path", { fill: "#FFF", d: "M7.993 10.667H1.958V6.895c0-.417.338-.754.754-.754h4.526c.417 0 .754.338.754.754v3.772z" }),
    _react2["default"].createElement("path", { fill: "#375EA3", d: "M9.667 3.334h4.5v.667h-4.5zM9.667 4.667h4.5v.667h-4.5z" })
  );
}

exports["default"] = IdentityUnchecked;
module.exports = exports["default"];